import { useQuery } from '@tanstack/react-query';
import { fetchPendingSession, UnauthorizedError } from '../api/auth';

export function usePendingSession(scopeKey: string | null) {
  const query = useQuery({
    queryKey: ['session', 'pending', scopeKey],
    queryFn: fetchPendingSession,
    enabled: Boolean(scopeKey),
    retry: false,
    staleTime: 0, // Always check, pending sessions are short-lived
    refetchOnMount: true,
    refetchOnWindowFocus: true,
    refetchOnReconnect: true,
  });

  return {
    ...query,
    isUnauthorized: query.error instanceof UnauthorizedError,
  };
}
